import { useForm, useFormContext } from 'react-hook-form';

export enum PlotOverviewFormFields {
  title = 'title',
  description = 'description',
}

export type ControlsFormFieldValues = {
  [PlotOverviewFormFields.title]: string;
  [PlotOverviewFormFields.description]: string;
};

export const usePlotOverviewForm = useForm<ControlsFormFieldValues>;

export const usePlotOverviewFormContext = useFormContext<ControlsFormFieldValues>;
